import { ReachAPI } from '../../ReachApi';
import { z } from 'zod';
import { forceTypingDeferred } from '../core';

type Ads = {
    getAdsForWidget: (
        widget_id: number,
        timestamp: number,
        timezone: string
    ) => JQueryDeferred<unknown>;
};

const adObjectSchema = z.object({
    adbundleid: z.number(),
    adid: z.number(),
    adname: z.string(),
    asset_uuid: z.string(),
    duration: z.number(),
    saturation: z.number(),
});

const adsForWidgetResponseSchema = z.object({
    ads: z.array(adObjectSchema),
});

/**
 * GET Endpoint `/ads/for_widget`
 * @throws {@link ReachApiRetrievalError}
 */
export const getAdsForWidget = function (
    widgetId: number,
    timestamp: number,
    timezone: string
): Promise<z.infer<typeof adsForWidgetResponseSchema>> {
    return forceTypingDeferred(
        adsForWidgetResponseSchema,
        (ReachAPI.ads as Ads).getAdsForWidget(widgetId, timestamp, timezone)
    );
};
